<template>
<div id="sms-pop" class="pop" key="sms-pop">
  <transition name="sms" mode="out-in">
    <div class="sms-pop__form" v-if="codeVisible">
      <h4 class="sms-pop__form-title">短信验证码</h4>
      <div class="form-row">
        <span class="sms-pop__phoneShow">手机号:   {{mobileShow}}</span>
      </div>
      <div class="form-row" style="margin-top: 20px;"><div class="sms-pop__code"><input v-model="smsCode" placeholder="验证码" class="sms-input xm-input__inner"/></div><button @click="_getSMSCode" :class="`sms-btn ${count > 0 ? ' disabled' : ''}`">{{ count > 0 ? (count + 's') : '获取验证码'}}</button></div>
      <div class="sms-pop__form-ctrl"><span class="error-msg">{{errorMsg}}</span><button @click="close" class="sms-code-btn btn-cancel">取消</button><button type="button" @click="toSubmit" class="sms-code-btn btn-confirm">确认</button></div>
    </div>
  </transition>
</div>
</template>

<script>
import api from '@/api'
  export default {
    data () {
      return {
        errorMsg: '',
        count: 0,
        smsCode: ''
      }
    },
    computed: {
      codeVisible () {
        return this.$store.state.SMSCodeVisible
      },
      mobileShow () {
        return this.$store.state.mobileShow
      },
      mobileReal () {
        return this.$store.state.mobileReal
      },
      toUrl () {
        return this.$store.state.toUrl
      }
    },
    watch: {
      codeVisible (val) {
        if (!val) {
          this.resetForm()
        }
      }
    },
    methods: {
      resetForm () {
        this.errorMsg = ''
        this.smsCode = ''
        clearTimeout(this.timer)
        this.count = 0
      },
      _getSMSCode () {
        const phone = this.mobileReal
        api.getMobileSMSCode({ phone }).then(res => {
          if (res.data.success) {
            this.startCountDown()
          } else {
            this.errorMsg = res.data.msg
          }
        })
      },
      countDown () {
        const { count } = this
        if (count <= 0) {
          return this.timer = null
        }
        this.count--
        this.timer = setTimeout(() => {
          this.countDown()
        }, 1000)
      },
      startCountDown (total = 60) {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.count = total
        this.countDown()
      },
      close () {
        this.$store.commit('hideSMSCode')
      },
      toSubmit () {
        const phone_num = this.mobileReal
        const smsCode = this.smsCode.trim()
        const checkKey = this.$store.state.checkKey
        const fromUri  = this.toUrl
        if (!smsCode) {
          return this.errorMsg = '验证码不能为空'
        }
        api.checkMobileSMSCode({
          phone_num,
          smsCode,
          checkKey
        }).then(res => {
          const { success, msg } = res.data
          if (success) {
            this.$store.commit('hideSMSCode')
            fromUri ? window.location.href = fromUri : window.location.reload()
            return true
          }
          this.errorMsg = msg
        })
      }
    }
  }
</script>

<style scoped lang="sass">
#sms-pop
  width: 440px
  .sms-enter-active,
  .sms-leave-active
    transition: all .6s ease
  .sms-enter,
  .sms-leave-to
    transform: translate3d(-50%, 50%, 0)
    opacity: 0
  .sms-pop__form
    position: fixed
    left: 50%
    top: 50%
    width: 440px
    padding: 20px
    box-sizing: border-box
    background: #fff
    border-radius: 6px
    transform: translate3d(-50%, -50%, 0)
  .disabled
    cursor: not-allowed
    pointer-events: none

  .sms-pop__phoneShow
    display: inline-block
    padding-top: 10px
    font-size: 18px
    line-height: 1.38
    color: #333

  .sms-pop__code
    display: inline-block
    vertical-align: middle
    width: 248px
    margin-right: 20px
    box-sizing: border-box

  .sms-input
    display: block
    width: 100%
    padding: 10px 20px
    border: 1px solid #E1E1E1
    font-size: 16px
    line-height: 1.38
    border-radius: 4px
    box-sizing: border-box
    &::-webkit-input-placeholder
      font-size: 16px

  .sms-pop__form-ctrl
    position: relative
    margin-top: 20px
    text-align: center
    .error-msg
      position: absolute
      bottom: 100%
      left: 0
      font-size: 12px
      line-height: 1.42
      color: #ff4949


  .sms-code-btn
    display: inline-block
    padding: 10px 20px
    font-size: 18px
    line-height: 1.38
    border-radius: 4px
    outline: none
    border: none
    cursor: pointer


  .btn-cancel
    width: 188px
    margin-right: 20px
    background: #E1E1E1
    color: #666
  .btn-confirm
    width: 188px
    background: #f86442
    background-image: linear-gradient(90deg, #FF9973 1%, #F86442 95%)
    color: #fff

  .sms-btn
    width: 127px
    padding: 10px 0
    vertical-align: middle
    text-align: center
    font-size: 16px
    line-heigt: 1.38
    color: #f86442
    border: 1px solid #F86442
    border-radius: 4px
    outline: none
    cursor: pointer
    box-sizing: border-box
    &.disabled
      border-color: #E1E1E1
      background: #E1E1E1
      color: #666
      cursor: not-allowed


  .sms-pop__form-title
    text-align: center
    font-size: 20px
    line-height: 1.37


</style>



// WEBPACK FOOTER //
// src/components/pop-smsCode.vue